import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, List, ListItem, ListItemIcon, 
    ListItemText, Divider, Grid, IconButton, Popover, Typography, FormGroup, FormControl, FormControlLabel, Checkbox, FormLabel } from '@mui/material'
import React, { useEffect, useState } from 'react'
import DashboardContainer from '../../components/DashboardContainer'
import PageContainer from '../../components/PageContainer'
import { AddorUpdateRecord, getList } from '../../redux/api/system'
import { Formik, Form } from 'formik'
import { useSnackbar } from 'notistack'
import { DataGrid } from '@mui/x-data-grid'
import TextInput from '../../components/common/TextInput'
import SelectInput from '../../components/common/SelectInput'
import { Edit, MoreVert, Link as LinkIcon, ZoomInMap, AccountTreeOutlined, ListSharp } from '@mui/icons-material';
import PublicOffIcon from '@mui/icons-material/PublicOff';
import { connect } from 'react-redux'
import CustomDataGrid from '../../components/CustomDataGrid'

const CheckboxField = ({ hasResource, resource, handleResourceChange, providedBy = true }) => {
    return (
        
        <div>
            <FormControlLabel
                className='mb-1 mt-1'
                control={
                    <Checkbox size='medium' checked={hasResource(resource.resourceID)} onChange={handleResourceChange} name={resource.resourceID} />
                }
                label={
                    <>
                        <span>
                            {resource.resourceName}
                        </span>
                        {
                            providedBy && 
                            <>
                                <br />
                                <small>
                                    Provided By: {resource.providedBy}
                                </small>
                            </>
                        }
                        <br />
                    </>
                }
            />
            <Divider />
        </div>
    )
}

const Roles = ({ user }) => {
    const [ showModal, setShowModal ] = useState(false);
    const [ processing, setProcessing ] = useState(false);
    const [ selectedRole, setSelectedRole ] = useState(null);
    const [ privileges, setPrivileges ] = useState([]);
    const [ resources, setResources ] = useState([]);
    const [ openDialog, setOpenDialog ] = useState(false);
    const [ openResourceDialog, setOpenResourceDialog ] = useState(false);
    const [ isEditing, setEditing ] = useState(false)
    const [ roles, setRoles ] = useState([]);
    const { enqueueSnackbar } = useSnackbar();
    const [ mapping, setMapping ] = useState(false);
    const [ deleteModal, setDeleteModal ] = useState(false);
    const [ isDeleting, setIsDeleting] = useState(false);
    const defaultRole = {
        // "roleID": "",
        "roleName": "",
    }

    const columns = [
        { 
            field: 'sn', headerName: 'S/N', flex: 0.1, sortable: false,
            renderCell: (params) => (
                <p
                    style={{ margin: 'auto' }}
                >
                    {params?.row?.sn}
                </p>
            )
        },
        
        {
            field: 'actions', headerName: 'Actions', flex: 0.2, sortable: false,
            renderCell: (params) => (
                <div className='action-icons' style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', width: '100%', padding: '0 0.5rem' }}>
                    <IconButton
                        size='small'
                        color="primary"
                        variant="outlined" title='Edit Dataset Domain' className='p-0 m-0'
                        onClick={() => {
                            setSelectedRole(params?.row || defaultRole);
                            setShowModal(true); setEditing(true);
                        }}
                    >
                        <Edit />
                    </IconButton>
                    <IconButton
                        size='small'
                        color="primary"
                        variant="outlined" title='Map privileges' className='p-0 m-0'
                        onClick={() => {
                            setSelectedRole(params?.row || defaultRole);
                            setOpenDialog(true)
                        }}
                    >
                        <AccountTreeOutlined />
                    </IconButton>
                    <IconButton
                        size='small'
                        color="primary"
                        variant="outlined" title='Map Resources' className='p-0 m-0'
                        onClick={() => {
                            setSelectedRole(params?.row || defaultRole);
                            setOpenResourceDialog(true)
                        }}
                    >
                        <ListSharp />
                    </IconButton>
                    <IconButton
                        size='small'
                        color="error"
                        variant="outlined" title='Delete Role' className='p-0 m-0'
                        onClick={() => {
                            setSelectedRole(params?.row ?? defaultRole);
                            setDeleteModal(true)
                        }}
                    >
                        <PublicOffIcon />
                    </IconButton>
                </div>
            )
        },
        { field: 'roleName', headerName: 'Role Name', flex: 1 },
    ];

    const init = async () => {
        try {
            setProcessing(true)
            const resp = await getList("roles");
            if(resp?.responseCode === "00") {
                setRoles(resp?.listing || []);
                const resPrivileges = await getList("privileges");
                const resourcesRes = await getList("user_resources");

                const listing = resourcesRes?.listing || [];
                const resources = await new Promise((resolve) => {
                    let res = [];
                    let length = -1;
                    let count = -1;
                    length = length + (listing?.length || 0);

                    listing?.forEach(({ resourceGroups, ...lt }) => {
                        count += 1;
                        length = length + (resourceGroups?.length || 0);
                        
                        resourceGroups?.forEach(({ resources, ...rG}) => {
                            count += 1;

                            length = length + (resources?.length || 0);

                            resources?.forEach(rs => {
                                count += 1;
                                res.push({
                                    ...rs,
                                    ...rG,
                                    ...lt
                                })
                            })
                        })
                    })

                    if(length == count) resolve(res);
                })

                setResources(resources || [])
                if(resPrivileges?.responseCode === "00") {
                    setPrivileges(resPrivileges?.listing || [])
                } else {
                    enqueueSnackbar(resp?.message || resp?.responseMessage || 'An error occurred', { variant: 'error' })
                }
            } else {
                enqueueSnackbar(resp?.message || resp?.responseMessage || 'An error occurred', { variant: 'error' })
            }

            
        }
        catch (err) {
            enqueueSnackbar(err?.message || err?.responseMessage || 'An error occurred', { variant: 'error' })
        }
        finally {
            setProcessing(false)
        }
    }

    const createOrUpdateRole = async (values, { resetForm }) => {
        try {
            const resp = await AddorUpdateRecord("role", isEditing ? "update" : 'add', values);
            if(resp?.responseCode === "00") {
                init();
                setEditing(false);
                setSelectedRole(null)
                setShowModal(false)
                enqueueSnackbar('Action performed successfully')
            } else {
                enqueueSnackbar(resp?.message || resp?.responseMessage || 'An error occurred', { variant: 'error' })
            }
        }
        catch (err) {
            enqueueSnackbar(err?.message || err?.responseMessage || 'An error occurred', { variant: 'error' })
        }
    };

    const handleChange = (event, value) => {
        let rolePrivileges = [ ...selectedRole?.privileges ] || [];
        if(value) {
            rolePrivileges.push({ id: parseInt(event.target.name) });
        } else {
            rolePrivileges = rolePrivileges.filter(({ id }) => id != parseInt(event.target.name))
        }
        setSelectedRole({ ...selectedRole, privileges: rolePrivileges })
    };

    const handleResourceChange = (event, value) => {
        let roleResources = [ ...selectedRole?.resources ] || [];
        if(value) {
            roleResources.push({ resourceID: parseInt(event.target.name) });
        } else {
            roleResources = roleResources.filter(({ resourceID }) => resourceID != parseInt(event.target.name))
        }
        setSelectedRole({ ...selectedRole, resources: roleResources })
    };

    const hasPrivilege = (privilege_id) => {
        return (selectedRole?.privileges?.map(x => String(x?.id))?.indexOf(String(privilege_id)) >= 0) ? true : false
    }

    const hasResource = (id) => {
        return (selectedRole?.resources?.map(x => String(x?.resourceID))?.indexOf(String(id)) >= 0) ? true : false
    }

    const deleteRole = async () => {
        try {
            setIsDeleting(true);

            const res = await AddorUpdateRecord("role", "delete", selectedRole);

            if(res.responseCode === "00") {
                init();
                setSelectedRole(null);
                setDeleteModal(false);
                enqueueSnackbar('Role deleted successfully', { variant: 'success' });
            }
            else {
                enqueueSnackbar(res?.message ?? res?.responseMessage ?? 'An error occurred', { variant: 'error' })
            }
        }
        catch (err) {
            enqueueSnackbar(err?.message ?? err?.responseMessage ?? 'An error occurred', { variant: 'error' })
        }
        finally {
            setIsDeleting(false);
        }
    }

    const handleMapping = async () => {
        try {
            setMapping(true)
            const resp = await AddorUpdateRecord("role", "update", { ...selectedRole, resources: selectedRole?.resources?.map(rs => ({ ...rs, id: rs?.resourceID })) || [] });
            if(resp?.responseCode === "00") {
                init();
                setMapping(false);
                setSelectedRole(null)
                setOpenDialog(false)
                setOpenResourceDialog(false)
                setShowModal(false)
                enqueueSnackbar('Mapping successful')
            } else {
                enqueueSnackbar(resp?.message || resp?.responseMessage || 'An error occurred', { variant: 'error' })
            }
        }
        catch (err) {
            enqueueSnackbar(err?.message || 'An error occurred', { variant: 'error' })
        }
        finally {
            setMapping(false)
        }
    };

    useEffect(() => {
        init()
    }, [])

    return (
        <PageContainer pageTitle='Users' processing={processing}>
            <section className="inner-banner parallax-section">
                <div className='overlay'>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 col-sm-12">
                                <h3 className="wow bounceIn" data-wow-delay="0.9s">User</h3>
                                <h1 className="wow fadeInUp text-uppercase conference mb-05 mt-05" data-wow-delay="1.6s">Roles</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className="services-area section-padding pt-3">
                <div className="container">
                    <div className="row">
                        <div className='col-12 text-align-right'>
                            <Button variant="contained" onClick={() => { setSelectedRole(defaultRole); setEditing(false); setShowModal(true) }}>Create New Role</Button>
                        </div>
                        <div className='col-12 mt-4'>
                            <div style={{ width: '100%', textAlign: 'center', height: 600 }}>
                                <CustomDataGrid 
                                    columns={columns}
                                    rows={roles}
                                />
                            </div>
                        </div>
                    </div>

                    <Dialog open={openDialog} onClose={() => { setOpenDialog(false); setSelectedRole(null) }} maxWidth='lg'>
                        <DialogTitle className='no-margin m-0 pt-2' style={{ textTransform: 'initial' }}>
                            <h4 className='m-0'>Map Privileges to Role: <b>{selectedRole?.roleName}</b></h4>
                        </DialogTitle>
                        <DialogContent style={{ height: '500px', width: '600px', padding: '0 2rem' }}>
                            <FormControl component="fieldset" variant="standard">
                                <FormGroup>
                                    {
                                        privileges.map(( privilege, key) => (
                                            <FormControlLabel
                                                control={
                                                    <Checkbox checked={hasPrivilege(privilege.id)} onChange={handleChange} name={privilege.id} />
                                                }
                                                label={privilege.description} key={key}
                                            />
                                        ))
                                    }
                                </FormGroup>
                            </FormControl>
                        </DialogContent>
                        <DialogActions style={{ padding: '1rem' }}>
                            <Button onClick={() => { setOpenDialog(false); setSelectedRole(null) }} color='secondary' variant='contained'>Cancel</Button>

                            <Button onClick={handleMapping} color='primary' variant='contained'>
                                { mapping ? <CircularProgress size={15} color='inherit' /> : 'Save Mapping' }
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog open={openResourceDialog} onClose={() => { setOpenResourceDialog(false); setSelectedRole(null) }} maxWidth='lg' className='resource-mapper'>
                        <DialogTitle className='no-margin m-0 pt-2' style={{ textTransform: 'initial' }}>
                            <h4 className='m-0'>Map Resources to Role: <b>{selectedRole?.roleName}</b></h4>
                        </DialogTitle>
                        <DialogContent style={{ height: '500px', minWidth: '600px', padding: '0 2rem' }}>
                            <FormControl component="fieldset" variant="standard" style={{ width: '100%' }}>
                                <FormLabel component="span" style={{ fontSize: "1.1em" }}>Resources from {user?.userData?.user_data?.institutionName}</FormLabel>
                                <FormGroup>
                                    {
                                        resources.filter(({ creator }) => 
                                            creator === user?.userData?.user_data?.institutionID
                                        ).map(( resource, key) => (
                                            <CheckboxField key={key} resource={resource} handleResourceChange={handleResourceChange} 
                                                hasResource={hasResource} providedBy={false}
                                            />
                                        ))
                                    }
                                </FormGroup>
                                
                                <FormLabel component="span" style={{ fontSize: "1.1em" }}>Resources from other institutions</FormLabel>
                                <FormGroup>
                                    {
                                        resources.filter(({ creator }) => 
                                            creator !== user?.userData?.user_data?.institutionID
                                        ).map(( resource, key) => (
                                            <CheckboxField key={key} resource={resource} handleResourceChange={handleResourceChange} 
                                                hasResource={hasResource}
                                            />
                                        ))
                                    }
                                </FormGroup>
                                
                            </FormControl>
                        </DialogContent>
                        <DialogActions style={{ padding: '1rem' }}>
                            <Button onClick={() => { setOpenResourceDialog(false); setSelectedRole(null) }} color='secondary' variant='contained'>Cancel</Button>

                            <Button onClick={handleMapping} color='primary' variant='contained'>
                                { mapping ? <CircularProgress size={15} color='inherit' /> : 'Save Mapping' }
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            </div>

            <Dialog open={showModal}>
                <Formik enableReinitialize initialValues={selectedRole} onSubmit={createOrUpdateRole}>
                    {({ isSubmitting, values }) => (
                        <Form>
                            <DialogContent className='pl-3 pr-3'>
                                <h3 className='text-bold mt-05' >{isEditing ? 'Update' : 'Create'} Role</h3>
                                <Divider className="mt-05 mb-2" />
                                <Grid container spacing={3}>
                                    {/* <Grid item xs={12}>
                                        <TextInput id="roleID" required label="Role Id" />
                                    </Grid> */}
                                    <Grid item xs={12}>
                                        <TextInput id="roleName" label="Role Name" />
                                    </Grid>
                                </Grid>
                            </DialogContent>
                            <DialogActions className='pr-3 pb-3'>
                                <Button onClick={() => { if(!isSubmitting) { setShowModal(false); selectedRole(null) }}} color="secondary" variant="contained" >Cancel</Button>
                                <Button type='submit' variant="contained">
                                    {
                                        isSubmitting ?
                                        <CircularProgress size={15} color="inherit" />
                                        :
                                        isEditing ? 'Update Role' : 'Add Role'
                                    }
                                </Button>
                            </DialogActions>
                        </Form>
                    )}
                </Formik>
            </Dialog>

            <Dialog open={deleteModal} maxWidth="lg">
                <DialogContent className='pl-4 pr-4'>
                    <p className='text-bold mt-05' style={{ fontSize: "1.2em" }} >Are you sure you want to <b style={{ color: "red" }}>delete the Role</b> from the system</p>
                    <Divider className="mt-2" />
                </DialogContent>
                <DialogActions className='pr-3 pb-3'>
                    <Button 
                        disabled={isDeleting} 
                        onClick={() => { 
                            if(!isDeleting) { 
                                setDeleteModal(false); 
                                setSelectedRole(null) 
                            }}} 
                        color="secondary" 
                        variant="contained" >
                            Cancel
                        </Button>
                    <Button variant="contained" disabled={isDeleting} onClick={deleteRole} >
                        {
                            isDeleting ?
                            <CircularProgress size={15} color="inherit" />
                            :
                            'Delete Role'
                        }
                    </Button>
                </DialogActions>
            </Dialog>
        </PageContainer>
    )
}

export default connect(({ user }) => ({ user }))(Roles)